import Sidebar from './Sidebar';
import ChatArea from './ChatArea';

export default function MainApp() {
  return (
    <div className="chat-frame">
      <div className="main-app">
        <ChatArea />
        <Sidebar />
      </div>
    </div>
  );
}
